<section class="relative lg:py-24 py-16">
  <div class="container">
      <div class="md:flex justify-center">
          <div class="md:w-9/12">
              <div class="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                  <h5 class="text-xl font-medium mb-4">Praktisch</h5>
                  <h4>Opstart van therapie</h4>
                  <p class="text-slate-400 omschrijving">
                    Hoe gaat het opstarten van therapie in zijn werk?<br /><br />
                    Hieronder vind je een stappenplan dat het hele proces weergeeft. Als je op een stap klikt, verschijnt er meer informatie. Dit proces wordt natuurlijk ook besproken tijdens het intakegesprek bij de logopediste.
                    <br /><br />
                  </p>
                  <h4>Terugbetaling</h4>
                  <p class="text-slate-400 omschrijving">
                    De terugbetaling van de sessies kan via de wettelijke RIZIV-terugbetaling of via de aanvullende verzekering van je mutualiteit lopen. Via de RIZIV-terugbetaling krijg je ongeveer 70 % van de tarieven terug van jouw mutualiteit. Aan dit systeem zijn wel een aantal voorwaarden verbonden. Zo zijn er bv. maximale testscores: als jouw kindje hoger scoort, kan er geen RIZIV-terugbetaling worden aangevraagd. Ook voor sommige stoornissen, zoals bv. een zuivere articulatiestoornis, kunnen we deze aanvraag niet doen.
                  </p>

                  <p class="text-slate-400 omschrijving mt-4">
                    Als een RIZIV-terugbetaling niet mogelijk is, kan je wel nog terugbetaling krijgen via de aanvullende verzekering van je mutualiteit. Je krijgt dan per sessie een vast bedrag terug, bij de meeste mutualiteiten ligt dat bedrag rond de € 10. Via dit systeem krijg je minder terug per sessie, maar er zijn geen strikte criteria waaraan je moet voldoen. Hoeveel sessies en terugbetaling er via aanvullende verzekering kunnen plaatsvinden, hangt af van jouw mutualiteit.
                  </p>
              </div>
            </div>
            <div class="w-full md:w-3/12">
              <img src="assets/images/logo-praktisch.jpg" class="w-full border-8 border-white dark:border-slate-900 rounded-md shadow dark:shadow-gray-700" alt="">
            </div>
        </div>
    </div>

    <!-- First part of list -->
    <div class="container mt-4">
        <div class="md:flex justify-center">
          <div class="md:w-full">
              <div class="p-4 bg-white">
                <h5 class="text-xl font-medium mb-4">Stappenplan</h5>

                <div id="accordion-collapse1" data-accordion="collapse" class="mt-2">
                  <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                      <h2 class="text-base font-semibold" id="accordion-collapse-heading-1">
                          <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-1" aria-expanded="false" aria-controls="accordion-collapse-body-1">
                              <span>Stap 1: Aanmelding via telefoon of e-mail</span>
                          </button>
                      </h2>
                      <div id="accordion-collapse-body-1" aria-labelledby="accordion-collapse-heading-1">
                          <div class="p-4">
                              <p class="text-slate-400 dark:text-gray-400 answer">
                                Je meldt je aan via <a class='text-earth-xdark' href='/contact'>telefoon, e-mail of via ons contactformulier</a>. Indien je kind na de schooluren begeleiding nodig heeft, wordt hij/zij op onze wachtlijst geplaatst. Van zodra er een plekje vrijkomt, contacteren we je om een intakegesprek in te plannen.<br />
                                Indien er een mogelijkheid bestaat om de begeleiding tijdens de schooluren te laten doorgaan (kleuters of lagere schoolkinderen met een revalidatiedossier), kan het frequent sneller gaan.
                              </p>
                              <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                          </div>
                      </div>
                  </div>
                </div>

                <div id="accordion-collapse2" data-accordion="collapse" class="mt-2">
                  <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                      <h2 class="text-base font-semibold" id="accordion-collapse-heading-2">
                          <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-2" aria-expanded="false" aria-controls="accordion-collapse-body-2">
                              <span>Stap 2: Intakegesprek bij de logopediste</span>
                          </button>
                      </h2>
                      <div id="accordion-collapse-body-2" class="hidden" aria-labelledby="accordion-collapse-heading-2">
                          <div class="p-4">
                              <p class="text-slate-400 dark:text-gray-400 answer">
                                Tijdens een eerste gesprek bekijken we samen de problemen die zich voordoen, de sterktes en zwaktes van je kind, de vragen van jullie als ouders en van de eventuele doorverwijzer, de hypotheses die getoetst dienen te worden en bespreken we welke onderzoeken mogelijk zijn. Labelen mag immers geen doel op zich zijn, maar moet bijdragen aan de behandeling in ruime zin van de leer-/ontwikkelingsproblemen. Daarnaast bespreken we de praktische kant, zoals de tarieven en aanvraagprocedure, en geven we de nodige documenten mee.<br /><br />Het is belangrijk dat jullie vrijuit kunnen spreken. Je kind moet dus niet noodzakelijk aanwezig zijn op dit moment.
                              </p>
                              <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                          </div>
                      </div>
                  </div>
                </div>

            </div>
          </div>
        </div>
      </div>

      <!-- Second part of list -->
      <div class="container mt-2">
        <div class="md:flex justify-center">
          <!-- Left column -->
          <div class="md:w-6/12">
            <div class="p-6 bg-white">

              <div class="text-center text-xl text-earth-xdark">Aanvraag via RIZIV<br /><i class="uil uil-arrow-down text-earth-xdark text-3xl mr-2"></i></div>

              <div id="accordion-collapse3a" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-3a">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-3a" aria-expanded="false" aria-controls="accordion-collapse-body-3a">
                            <span>Stap 3: Doktersvoorschrift voor onderzoek</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-3a" class="hidden" aria-labelledby="accordion-collapse-heading-3a">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Je haalt een voorschrift voor logopedisch onderzoek (het bilan) bij de huisarts of een specialist (kinderarts, kinderpsychiater, NKO-arts). Zonder dit voorschrift kan de logopediste geen onderzoek uitvoeren.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse4a" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-4a">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-4a" aria-expanded="false" aria-controls="accordion-collapse-body-4a">
                            <span>Stap 4: Logopedisch onderzoek</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-4a" class="hidden" aria-labelledby="accordion-collapse-heading-4a">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Je logopediste neemt een basismeting af bij je kind, meestal tijdens de schooluren. Hiermee wordt het huidige niveau van je kind bepaald. Dit wordt ongeveer na een jaar therapie herhaald. Om het best mogelijke advies te kunnen geven, is een uitgebreide diagnostiek een belangrijk startpunt, echter komt dit frequent niet overeen met de terugbetaling die voorzien wordt door mutualiteiten. Dit zal de logopediste tijdens het intakegesprek nader toelichten.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse5a" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-5a">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-5a" aria-expanded="false" aria-controls="accordion-collapse-body-5a">
                            <span>Stap 5: Bespreking onderzoek</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-5a" class="hidden" aria-labelledby="accordion-collapse-heading-5a">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              De resultaten van het onderzoek, alsook adviezen worden besproken. Er wordt bekeken of het nodig is dat je kind op therapie komt of niet. Je logopediste zal ook uitleggen of er voldaan is aan de criteria voor een RIZIV-aanvraag. Als dat niet zo is, bespreekt zij welke mogelijkheden er nog zijn.
                            </p>
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Als therapie niet nodig blijkt, kan de logopediste wel extra informatie geven zodat jullie thuis alsnog extra kunnen oefenen.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse5ba" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-5ba">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-5ba" aria-expanded="false" aria-controls="accordion-collapse-body-5ba">
                            <span>(Stap 5B: Eventueel bijkomend onderzoek)</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-5ba" class="hidden" aria-labelledby="accordion-collapse-heading-5ba">
                        <div class="p-4">
                          <p class="text-slate-400 dark:text-gray-400 answer">
                            Voor een aanvraag bij taalproblemen is het nodig dat er een IQ- en gehoortest worden afgenomen. De IQ-test kan afgenomen worden door de psycholoog/orthopedagoog bij ons in de praktijk.
                          </p>

                          <p class="text-slate-400 dark:text-gray-400 answer mt-4">
                            Multidisciplinair werken dragen we ook binnen het diagnostische werkveld hoog in het vaandel: indien nodig geacht, zal u worden doorverwezen naar de psycholoog/orthopedagoog of psychomotorisch therapeute voor een evaluatie van deze vaardigheden. Ook de samenwerking met een ervaren kinderpsychiater behoort tot ons aanbod. De verschillende disciplines overleggen op regelmatige basis.
                          </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse6a" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-6a">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-6a" aria-expanded="false" aria-controls="accordion-collapse-body-6a">
                            <span>Stap 6: Doktersvoorschrift voor therapie</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-6a" class="hidden" aria-labelledby="accordion-collapse-heading-6a">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Je haalt een voorschrift voor logopedische therapie bij de specialist (kinderneuroloog, -psychiater, NKO- of kinderarts). Zonder dit voorschrift kan de therapie niet worden opgestart.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse7a" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-7a">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-7a" aria-expanded="false" aria-controls="accordion-collapse-body-7a">
                            <span>Stap 7: Opstart van therapie</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-7a" class="hidden" aria-labelledby="accordion-collapse-heading-7a">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              De logopediste stuurt het dossier op naar jouw mutualiteit voor goedkeuring. De therapie kan nu worden opgestart!
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

            </div>
          </div>
          <!-- Right column -->
          <div class="md:w-6/12">
            <div class="p-6 bg-white">

              <div class="text-center text-xl text-earth-xdark">Aanvraag via aanvullende verzekering<br /><i class="uil uil-arrow-down text-earth-xdark text-3xl mr-2"></i></div>

              <div id="accordion-collapse4b" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-4b">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-4b" aria-expanded="false" aria-controls="accordion-collapse-body-4b">
                            <span>Stap 3: Logopedisch onderzoek</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-4b" class="hidden" aria-labelledby="accordion-collapse-heading-4b">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Je logopediste neemt een basismeting af bij je kind. Hiermee wordt het huidige niveau van je kind bepaald. Om het best mogelijke advies te kunnen geven, is een uitgebreide diagnostiek een belangrijk startpunt, echter komt dit frequent niet overeen met de terugbetaling die voorzien wordt door mutualiteiten. Dit zal de logopediste tijdens het intakegesprek nader toelichten.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse5b" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-5b">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-5b" aria-expanded="false" aria-controls="accordion-collapse-body-5b">
                            <span>Stap 4: Bespreking onderzoek</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-5b" class="hidden" aria-labelledby="accordion-collapse-heading-5b">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              De resultaten van het onderzoek, alsook adviezen worden besproken. Er wordt bekeken of het nodig is dat je kind op therapie komt of niet.
                            </p>
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Als therapie niet nodig blijkt, kan de logopediste wel extra informatie geven zodat jullie thuis alsnog extra kunnen oefenen.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse6b" data-accordion="collapse" class="mt-2">
                <div class="relative shadow rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-6b">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-6b" aria-expanded="false" aria-controls="accordion-collapse-body-6b">
                            <span>Stap 5: Doktersvoorschrift voor therapie<br /><span class="text-xs font-normal">(Afhankelijk van mutualiteit)</span></span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-6b" class="hidden" aria-labelledby="accordion-collapse-heading-6b">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Bij aanvragen via de aanvullende verzekering hangt het af van je mutualiteit of er een voorschrift nodig is voor de therapie. Je logopedist laat je weten of het nodig is of niet.
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

              <div id="accordion-collapse7b" data-accordion="collapse" class="mt-2">
                <div class="relative shadow dark:shadow-gray-800 rounded-md overflow-hidden">
                    <h2 class="text-base font-semibold" id="accordion-collapse-heading-7b">
                        <button type="button" class="flex justify-between items-center p-4 w-full font-semibold text-left hover:bg-earth-dark/20" data-accordion-target="#accordion-collapse-body-7b" aria-expanded="false" aria-controls="accordion-collapse-body-7b">
                            <span>Stap 6: Opstart van therapie</span>
                        </button>
                    </h2>
                    <div id="accordion-collapse-body-7b" class="hidden" aria-labelledby="accordion-collapse-heading-7b">
                        <div class="p-4">
                            <p class="text-slate-400 dark:text-gray-400 answer">
                              Indien nodig stuurt de logopediste de vereiste documenten op naar jouw mutualiteit. De therapie kan nu worden opgestart!
                            </p>
                            <!--<img class="w-5/5 mx-auto mt-2" *ngIf="faq?.foto" [src]="faq.foto" />-->
                        </div>
                    </div>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>

      <div class="container mt-8">
        <div class="md:flex justify-center">
            <div class="md:w-full">
                <div class="p-6 bg-white dark:bg-slate-900 shadow dark:shadow-gray-700 rounded-md">
                    <h5 class="text-xl font-medium mb-4">Tarieven</h5>
                    <!--<p class="text-slate-400 omschrijving">
                      Onderstaand vind je de tarieven die we in onze praktijken hanteren. Geniet jij van een verhoogde tegemoetkoming bij je mutualiteit? Dan is voor jou de laatste kolom van toepassing.
                    </p>
                    <p class="text-slate-400 omschrijving mt-4">
                      <strong>LET OP!</strong> Het remgeld, vermeld in de tabel, betreft een aanvraag via de wettelijke RIZIV-terugbetaling. Indien dit niet mogelijk is, kan je wel nog terugbetaling krijgen via de aanvullende verzekering van je mutualiteit. Hoeveel sessies en terugbetaling er via aanvullende verzekering kunnen plaatsvinden, hangt af van jouw mutualiteit.
                    </p>
                    <img class="mt-8 w-6/12 border-2 border-black" src="assets/images/logo-tarieven.png" />-->
                    <p>Om de meest recente tarieven te bekijken, kan u een kijkje nemen op <a class='text-earth-xdark' href='/praktisch'>de pagina met praktische informatie</a>.<br />In het item 'Tarieven logopedisten' kan u alle info vinden.</p>
                </div>
              </div>
          </div>
      </div>
</section>
